export default __webpack_public_path__ + "static/media/landscape5.0af4894b.jpg";